/**
 * Fun Store (chokyo) navigation structure.
 * CLAW-426: Handles corrected to match actual Medusa DB handles.
 * 
 * This is hardcoded because chokyo categories are flat (no parent-child relationships).
 * Each item links to /categories/{handle} where the handle exists in Medusa.
 */

export interface NavSubItem {
  label: string
  handle: string
}

export interface NavGroup {
  label: string
  handle?: string
  items: NavSubItem[]
}

export interface NavMegaMenu {
  label: string
  handle: string
  groups: NavGroup[]
}

export interface NavDropdown {
  label: string
  handle: string
  items: NavSubItem[]
}

export interface NavLink {
  label: string
  href: string
}

export interface FunStoreNav {
  megaMenus: NavMegaMenu[]
  dropdowns: NavDropdown[]
  links: NavLink[]
}

export const FUN_STORE_NAV: FunStoreNav = {
  megaMenus: [
    {
      label: 'Cat',
      handle: 'cat',
      groups: [
        {
          label: 'Food & Treats',
          items: [
            { label: 'Dry Food', handle: 'dry-food' },
            { label: 'Wet Food', handle: 'cat-wet-food' },
            { label: 'Treats', handle: 'cat-treats' },
          ],
        },
        {
          label: 'Litter & Litter Box',
          handle: 'litter-accessories',
          items: [
            { label: 'Cat Litter', handle: 'cat-litter' },
            { label: 'Litter Box & Accessories', handle: 'cat-litter-boxes-accessories' },
            { label: 'Cat Litter Box', handle: 'cat-litter-box' },
          ],
        },
        {
          label: 'Cat Furniture',
          handle: 'cat-furniture',
          items: [
            { label: 'Cat Trees & Towers', handle: 'cat-tree' },
            { label: 'Scratchers', handle: '-cat-scratchers-collection-stylish-comfort-for-every-feline' },
          ],
        },
        {
          label: 'Feeding & Bowls',
          handle: 'feeding',
          items: [
            { label: 'Slow Feeder & Travel Bowls', handle: '-slow-feeder-bowls-travel-feeder-bowls' },
          ],
        },
        {
          label: 'Travel & Carriers',
          handle: 'carrier',
          items: [
            { label: 'Trolleys / Strollers', handle: 'trolleys-strollers' },
          ],
        },
        {
          label: 'Toys & Enrichment',
          items: [
            { label: 'Interactive Puzzle Toys', handle: 'interactive-puzzle-toy-for-dogs-cats-press-rotate-reward-play' },
            { label: 'Wand Toys & Teasers', handle: '-cat-teasers-collection-interactive-playtime-for-happy-cats' },
          ],
        },
        {
          label: 'Grooming & Wellness',
          items: [
            { label: 'Bath & Cleaning', handle: 'bath-cleaning-gentle-care-for-every-whisker-and-paw-' },
            { label: 'Brush & Deshedding', handle: 'brush-deshedding' },
          ],
        },
        {
          label: 'Accessories',
          items: [
            { label: 'Leash & Clothing', handle: 'leash-clothing' },
            { label: 'Bedding & Comfort', handle: 'bedding-comfort' },
          ],
        },
      ],
    },
    {
      label: 'Dog',
      handle: 'dog',
      groups: [
        {
          label: 'Food & Treats',
          items: [
            { label: 'Dry Food', handle: 'dog-dry-food' },
            { label: 'Wet Food', handle: 'dog-wet-food' },
            { label: 'Fresh Dog Food', handle: 'fresh-dog-food' },
            { label: 'Freeze Dried Treats', handle: 'freeze-dried-treats' },
            { label: 'Dog Treats', handle: 'dog-treats' },
            { label: 'Dental Chews', handle: 'dental-chews' },
            { label: 'Inaba/Ciao', handle: 'inaba-ciao' },
          ],
        },
        {
          label: 'Pee & Toilet',
          handle: 'pee-toilet',
          items: [
            { label: 'Indoor Dog Toilets / Grids / Grass Pads', handle: 'indoor-dog-toilets-grids-grass-pads' },
            { label: 'Cleaning & Deodorizer', handle: 'cleaning-deodorizer' },
          ],
        },
        {
          label: 'Travel & Carriers',
          handle: 'carrier',
          items: [
            { label: 'Trolleys / Strollers', handle: 'trolleys-strollers' },
          ],
        },
        {
          label: 'Accessories',
          items: [
            { label: 'Leash & Clothing', handle: 'leash-clothing' },
          ],
        },
        {
          label: 'Toys & Enrichment',
          items: [
            { label: 'Interactive Puzzle Toys', handle: 'interactive-puzzle-toy-for-dogs-cats-press-rotate-reward-play' },
          ],
        },
        {
          label: 'Grooming & Wellness',
          items: [
            { label: 'Bath & Cleaning', handle: 'bath-cleaning-gentle-care-for-every-whisker-and-paw-' },
            { label: 'Brush & Deshedding', handle: 'brush-deshedding' },
          ],
        },
        {
          label: 'Bedding & Comfort',
          handle: 'bedding-comfort',
          items: [
            { label: 'Bedding', handle: 'bedding' },
          ],
        },
        {
          label: 'Feeding & Bowls',
          handle: 'feeding',
          items: [
            { label: 'Slow Feeder & Travel Bowls', handle: '-slow-feeder-bowls-travel-feeder-bowls' },
          ],
        },
      ],
    },
  ],
  dropdowns: [
    {
      label: 'Small Animals',
      handle: 'small-animals',
      items: [
        { label: 'Food & Treats', handle: '-small-animals-food-treats-nutrition-made-simple-natural' },
        { label: 'Activity Toys', handle: '-small-animal-toys-keep-little-paws-busy-happy' },
        { label: 'Bedding & Housing', handle: 'small-animals-bedding-housing' },
      ],
    },
  ],
  links: [],
}
